import React, {Component} from 'react';

import Image from 'next/image';
import {withRouter} from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ButtonElement from 'Frontend/components/ButtonElement';
import Form from 'Frontend/components/quickInterview/Form';
import SearchDecoration from 'Frontend/components/quickInterview/SearchDecoration';

import pricayIcon from 'Frontend/assets/images/dataPrivacyIcon';
import {FONTS} from 'Frontend/utils/fonts';
import {clampCss, pxToVw} from 'Frontend/utils/helpers';
import {MEDIA} from 'Frontend/utils/mediaQueries';


/**
 * InfoInput
 *
 * @property {*} prop Prop comment.
 *
 * @class InfoInput
 * @extends {Component}
 */
class InfoInput extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object,
        onHandleDataChange: PropTypes.func,
        onHandleSubmit: PropTypes.func
    }

    static defaultProps = {
        data: {},
        errors: {},
        onHandleDataChange() {},
        onHandleSubmit() {}
    }

    /**
     * Renders the Component.
     *
     * @returns {JSX} Component.
     * @memberof QuickInterview
     */
    render() {
        const {data, errors, onHandleDataChange, onHandleSubmit} = this.props;
        const text = (
            <>
                Gleich kannst du unsere Empfehlungen einsehen. Unser Service beinhaltet außerdem
                ein <strong>Beratungsgespräch</strong> mit den ausgesuchten Zweithaar-Experten, die
                dich <strong>einmalig</strong> für eine <strong>unverbindliche</strong>{' '}
                und <strong>kostenlose Beratung</strong> anrufen. Das hilft dir schnell einen
                Vergleich zu bekommen.
            </>
        );

        return (
            <>
                <InputWrapper>
                    <InputContainer>
                        <Text>{text}</Text>
                        <Spacer />
                        <Form data={data} errors={errors} onChange={onHandleDataChange} />
                        <Spacer />
                        <Button onClick={onHandleSubmit}>
                            Angebote erhalten
                        </Button>
                        <ImageContainer>
                            <Image height={150} src={pricayIcon} width={150} />
                        </ImageContainer>
                    </InputContainer>
                </InputWrapper>
                <ColumnSpacer />
                <SearchDecorationContainer>
                    <SearchDecoration />
                </SearchDecorationContainer>
            </>
        );
    }
}

export default withRouter(InfoInput);


const ImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 24px;
    width: 100%;
    
    ${MEDIA.TABLET.UP} {
        display: flex;
    }

    ${MEDIA.DESKTOP.UP} {
        display: none;
    }
`;

const Button = styled(ButtonElement).attrs({as: 'button'})`
    outline: none;
    border: none;
    margin: auto;

    ${MEDIA.TABLET.UP} {
        margin: auto;
    }

    ${MEDIA.DESKTOP.UP} {
        margin: 0;
    }
`;

const Spacer = styled.div`
    height: 32px;
`;

const InputWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row nowrap;
    justify-content: center;
    margin-bottom: 120px;
    margin-left: ${clampCss(24, 'm')};
    margin-right: ${clampCss(24, 'm')};
    margin-top: 56px;

    ${MEDIA.TABLET.UP} {
        margin-left: ${clampCss(24, 't')};
        margin-right: ${clampCss(24, 't')};
    }

    ${MEDIA.DESKTOP.UP} {
        justify-content: flex-end;
        margin-left: max(24px, ${pxToVw(24, 'd')});
        margin-right: max(120px, ${pxToVw(120, 'd')});
    }
`;

const InputContainer = styled.div`
    max-width: 100%;

    ${MEDIA.TABLET.UP} {
        max-width: ${clampCss(680, 't')};
    }

    ${MEDIA.DESKTOP.UP} {
        max-width: max(408px, ${pxToVw(408, 'd')});
    }
`;

const ColumnSpacer = styled.div`
    display: none;
    width: 90px;

    ${MEDIA.DESKTOP.UP} {
        display: block;
    }
`;

const SearchDecorationContainer = styled.div`
    display: flex;
    overflow: hidden;
    padding-bottom: ${clampCss(80, 'm')};

    width: 0px;

    ${MEDIA.TABLET.UP} {
        padding-bottom: ${clampCss(80, 't')};
        width: 0px;
    }

    ${MEDIA.DESKTOP.UP} {
        flex: 1;
        padding-bottom: max(180px, ${pxToVw(180, 'd')});
        width: auto;
    }
`;

const Text = styled.p`
    ${FONTS.REGULAR}
    color: ${({theme}) => theme.colors.textColor};
    font-size: ${clampCss(12, 'm')};
    letter-spacing: ${clampCss(0.5, 'm')};
    line-height: ${clampCss(16.8, 'm')};
    margin: ${clampCss(16, 'm')} 0 0 0;
    text-align: center;

    ${MEDIA.TABLET.UP} {
        text-align: left;
        font-size: ${clampCss(12, 't')};
        letter-spacing: ${clampCss(0.5, 't')};
        line-height: ${clampCss(16.8, 't')};
        margin-top: ${clampCss(16, 't')};
    }

    ${MEDIA.DESKTOP.UP} {
        font-size: max(12px, ${pxToVw(12, 'd')});
        letter-spacing: max(0.5px, ${pxToVw(0.5, 'd')});
        line-height: max(16.8px, ${pxToVw(16.8, 'd')});
        margin-top: max(16px, ${pxToVw(16, 'd')});
    }
`;